import { render, staticRenderFns } from "./fdleorirates.vue?vue&type=template&id=b75836bc&scoped=true&"
import script from "./fdleorirates.vue?vue&type=script&lang=js&"
export * from "./fdleorirates.vue?vue&type=script&lang=js&"
import style0 from "./fdleorirates.vue?vue&type=style&index=0&id=b75836bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75836bc",
  null
  
)

export default component.exports